// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Rational_Serialized from "../Data.Rational.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_VatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Rational_Serialized.eqRational);
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString));
var eq4 = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var eq5 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_VatRate.eqVatRate));
var eq6 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var allowedContainersIsSymbol = {
    reflectSymbol: function () {
        return "allowedContainers";
    }
};
var volumeIsSymbol = {
    reflectSymbol: function () {
        return "volume";
    }
};
var showArray = /* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId);
var PackagingContainersConfigIsSymbol = {
    reflectSymbol: function () {
        return "PackagingContainersConfig";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var decodeArray1 = /* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId);
var capacityIsSymbol = {
    reflectSymbol: function () {
        return "capacity";
    }
};
var enabledIsSymbol = {
    reflectSymbol: function () {
        return "enabled";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var priceIsSymbol = {
    reflectSymbol: function () {
        return "price";
    }
};
var vatRateIsSymbol = {
    reflectSymbol: function () {
        return "vatRate";
    }
};
var PackagingContainerIsSymbol = {
    reflectSymbol: function () {
        return "PackagingContainer";
    }
};
var ProductIdIsSymbol = {
    reflectSymbol: function () {
        return "ProductId";
    }
};
var genericShowArgsArgument = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId);
var ModifierItemIdIsSymbol = {
    reflectSymbol: function () {
        return "ModifierItemId";
    }
};
var genericDecodeManyArgsArgu = /* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId);
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Rational_Serialized.encodeRational);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId));
var genericEncodeArgsArgument = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId));
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Rational_Serialized.decodeRational);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId));
var genericDecodeArgsArgument = /* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId));
var PackagingContainersConfig = function (x) {
    return x;
};
var PackagingContainer = function (x) {
    return x;
};
var ProductId = /* #__PURE__ */ (function () {
    function ProductId(value0) {
        this.value0 = value0;
    };
    ProductId.create = function (value0) {
        return new ProductId(value0);
    };
    return ProductId;
})();
var ModifierItemId = /* #__PURE__ */ (function () {
    function ModifierItemId(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ModifierItemId.create = function (value0) {
        return function (value1) {
            return new ModifierItemId(value0, value1);
        };
    };
    return ModifierItemId;
})();
var toFillFormTypePackagingCo = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypePackagingCo1 = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeContainedId = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypePackagingContainer = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePackagingContainer1 = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPackagingContaine = function (dictHasField) {
    return dictHasField;
};
var hasFieldPackagingContaine1 = function (dictHasField) {
    return dictHasField;
};
var eqPackagingContainersConf = {
    eq: function (x) {
        return function (y) {
            return eq(x.allowedContainers)(y.allowedContainers) && eq1(x.volume)(y.volume);
        };
    }
};
var eqPackagingContainer = {
    eq: function (x) {
        return function (y) {
            return eq1(x.capacity)(y.capacity) && x.enabled === y.enabled && eq3(x.name)(y.name) && eq4(x.price)(y.price) && eq5(x.vatRate)(y.vatRate);
        };
    }
};
var eqContainedId = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ProductId && y instanceof ProductId) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ModifierItemId && y instanceof ModifierItemId) {
                return eq6(x.value0)(y.value0) && eq6(x.value1)(y.value1);
            };
            return false;
        };
    }
};
var genericPackagingContainersConfig = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPackagingContainersConfig = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPackagingContainersConfig)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(allowedContainersIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(volumeIsSymbol)(Data_Rational_Serialized.showRational))(showArray))))(PackagingContainersConfigIsSymbol))
};
var unscrambleDecodePackagingContainersConfig = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPackagingContainersConfig)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(allowedContainersIsSymbol)(decodeArray1)(/* #__PURE__ */ Unscramble.decodeRecordCons(volumeIsSymbol)(Data_Rational_Serialized.udecodeRational)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericPackagingContainer = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPackagingContainer = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPackagingContainer)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(capacityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(enabledIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(nameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(priceIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(vatRateIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_VatRate.showVatRate)))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(Data_Show.showBoolean))(Data_Rational_Serialized.showRational))))(PackagingContainerIsSymbol))
};
var unscrambleDecodePackagingContainer = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPackagingContainer)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(capacityIsSymbol)(Data_Rational_Serialized.udecodeRational)(/* #__PURE__ */ Unscramble.decodeRecordCons(enabledIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons(priceIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(vatRateIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_VatRate.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var genericContainedId = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ProductId(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new ModifierItemId(x.value0.value0, x.value0.value1);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.PackagingContainer (line 87, column 1 - line 87, column 77): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ProductId) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ModifierItemId) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.PackagingContainer (line 87, column 1 - line 87, column 77): " + [ x.constructor.name ]);
    }
};
var showContainedId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericContainedId)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showArray))(ProductIdIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument)(genericShowArgsArgument))(ModifierItemIdIsSymbol)))
};
var unscrambleDecodeContainedId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericContainedId)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ProductIdIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(decodeArray1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgs1(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsProd(genericDecodeManyArgsArgu)(genericDecodeManyArgsArgu)))(ModifierItemIdIsSymbol))))(Unscramble_Generic.defaultOptions)
};
var encodePackagingContainersConfig = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPackagingContainersConfig)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PackagingContainersConfigIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(volumeIsSymbol)(encodeWithOptionsOther))(allowedContainersIsSymbol)(encodeWithOptionsOther1)))))
};
var encodePackagingContainer = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPackagingContainer)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PackagingContainerIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(vatRateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_VatRate.encodeVatRate))))(priceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))(nameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))(enabledIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))(capacityIsSymbol)(encodeWithOptionsOther)))))
};
var encodeContainedId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericContainedId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ProductIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(encodeWithOptionsOther1)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ModifierItemIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsProduct(genericEncodeArgsArgument)(genericEncodeArgsArgument))))
};
var decodePackagingContainersConfig = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPackagingContainersConfig)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PackagingContainersConfigIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(volumeIsSymbol)(decodeWithOptionsOther)())(allowedContainersIsSymbol)(decodeWithOptionsOther1)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePackagingContainer = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPackagingContainer)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PackagingContainerIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(vatRateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_VatRate.decodeVatRate)))())(priceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())(nameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())(enabledIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())(capacityIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeContainedId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericContainedId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ProductIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(decodeWithOptionsOther1))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ModifierItemIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsProduct(genericDecodeArgsArgument)(genericDecodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))))
};
export {
    PackagingContainersConfig,
    PackagingContainer,
    ProductId,
    ModifierItemId,
    genericPackagingContainersConfig,
    eqPackagingContainersConf,
    showPackagingContainersConfig,
    encodePackagingContainersConfig,
    decodePackagingContainersConfig,
    unscrambleDecodePackagingContainersConfig,
    toFillFormTypePackagingCo1,
    hasFieldPackagingContaine1,
    newtypePackagingContainer1,
    genericPackagingContainer,
    eqPackagingContainer,
    showPackagingContainer,
    encodePackagingContainer,
    decodePackagingContainer,
    unscrambleDecodePackagingContainer,
    toFillFormTypePackagingCo,
    hasFieldPackagingContaine,
    newtypePackagingContainer,
    genericContainedId,
    eqContainedId,
    showContainedId,
    encodeContainedId,
    decodeContainedId,
    unscrambleDecodeContainedId,
    toFillFormTypeContainedId
};
